<template lang="html">
  <div>
    <v-app-bar app flat color="white" class="app-bar-no-padding">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="d-flex align-center">
              <div class="font-18 font-weight-bold">
                {{ $t('product.bank_transfer') }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <div class="mb-2 d-flex align-center">
            <div class="font-14">
              {{ $t('dialog.pay_to') }}
            </div>
            <v-spacer />
            <div v-if="!$isEmpty(order.payment_log)">
              <v-img :src="order.payment_log.payment_image" contain width="50" height="28" />
            </div>
          </div>
          <div
            v-if="!$isEmpty(order.payment_log)"
            class="card--input card-va-number d-flex align-center pa-0"
          >
            <div class="font-weight-bold font-18 px-3">
              {{ order.payment_log.va_account_number }}
            </div>
            <v-spacer />
            <input
              id="va_account_number"
              type="hidden"
              :value="order.payment_log.va_account_number"
            />
            <v-btn
              class="pa-0"
              text
              color="primary"
              min-width="40"
              width="40"
              height="40"
              @click="copyText()"
            >
              <v-icon size="24"> mdi-content-copy </v-icon>
            </v-btn>
          </div>
          <div v-if="!$isEmpty(order.payment_log)" class="mt-4">
            <div class="container-time">
              <div class="va-icon-time">
                <v-icon color="#FF931E"> mdi-clock </v-icon>
              </div>
              <div class="va-content-time">
                <div class="va-content-title">
                  {{ formatDate }}
                </div>
                <div class="va-content-subtitle">
                  {{ $t('dialog.finish_payment_before') }}
                </div>
              </div>
              <div class="va-action">
                <div class="va-action-time">
                  {{ formattedTimeLeft }}
                </div>
              </div>
            </div>
          </div>
          <v-btn
            color="#F5F5F5"
            height="40"
            block
            class="text-none mt-6 font-weight-bold border-radius-5"
            @click="goToOrder(order.id)"
          >
            {{ $t('dialog.detail_order') }}
          </v-btn>
          <v-btn
            v-if="
              formattedTimeLeft !== $t('v2.expired') &&
              !order.is_paid &&
              order.status !== 'X' &&
              order.payment_mode_id !== 10
            "
            color="primary"
            text
            block
            height="40"
            class="text-none font-weight-700 mt-4 letter-space-0"
            @click="changePayment()"
          >
            {{ $t('v2.use_other_payment_method') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <v-expansion-panels
            v-if="order.payment_log && order.payment_log.va_bank_code"
            v-model="panel_va"
            class="panel-guide"
          >
            <template v-if="order.payment_log.va_bank_code === 'MANDIRI'">
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1"> ATM </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('atm_mandiri.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  Mobile Banking
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('mobile_mandiri.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  Internet Banking
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('internet_mandiri.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </template>
            <template v-if="order.payment_log.va_bank_code === 'BNI'">
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1"> ATM </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('atm_bni.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  Mobile Banking BNI
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('mobile_banking_bni.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  Internet Banking BNI
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('internet_banking_bni.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </template>
            <template v-if="order.payment_log.va_bank_code === 'BRI'">
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1"> ATM </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('atm_bri.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  Mobile Banking
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('mobile_bri.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  Internet Banking
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('internet_bri.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </template>
            <template v-if="order.payment_log.va_bank_code === 'PERMATA'">
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  ATM PRIMA / ALTO:
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('atm_permata.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  Permata Mobile X
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('permata_mobile_x.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  Permata Mobile
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('permata_mobile.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  Internet Banking Permata (PermataNet)
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('permata_ib.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </template>
            <template v-if="order.payment_log.va_bank_code === 'BCA'">
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  BCA M-Mobile
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('bca_mobile.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1"> ATM </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('atm_bca.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1"> IBanking </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('internet_banking_bca.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </template>
            <template v-if="order.payment_log.va_bank_code === 'SAHABAT_SAMPOERNA'">
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1"> ATM </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('atm_sahabat_sampoerna.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  Mobile Banking
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('mobile_sahabat_sampoerna.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="subtitle-1">
                  Internet Banking
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ol>
                    <li
                      v-for="(step, index) in $t('internet_sahabat_sampoerna.steps', {
                        va_account: order.payment_log.va_account_number
                      })"
                      :key="index"
                      v-html="step"
                    />
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </template>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <div v-if="!order.is_paid" class="menu-bottom">
        <div class="wrap-menu-bottom">
          <v-container :class="['d-flex', { 'pa-0': $vuetify.breakpoint.width > 600 }]">
            <v-row :class="[{ 'ma-0 fill-height': $vuetify.breakpoint.width > 600 }]">
              <v-col cols="12" class="py-0" :class="[{ 'px-0': $vuetify.breakpoint.smAndDown }]">
                <div class="d-flex fill-height align-center justify-center">
                  <v-btn
                    v-if="
                      order.status_mark === 'waiting_for_payment' &&
                      formattedTimeLeft !== $t('v2.expired')
                    "
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="getOrder()"
                  >
                    {{ $t('v2.check_payment_status') }}
                  </v-btn>
                  <v-btn
                    v-else-if="
                      formattedTimeLeft === $t('v2.expired') &&
                      (order.status === 'x' || order.status === 'z')
                    "
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="changePayment(1)"
                  >
                    Pesan ulang
                    <span class="ml-2">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.89 10.105C19.676 9.6 19.411 9.11 19.101 8.649L17.443 9.768C17.681 10.12 17.884 10.495 18.047 10.883C18.215 11.281 18.344 11.696 18.43 12.113C18.518 12.546 18.563 12.991 18.563 13.437C18.563 13.883 18.518 14.33 18.43 14.761C18.344 15.179 18.216 15.592 18.046 15.992C17.884 16.378 17.681 16.753 17.443 17.104C17.209 17.451 16.938 17.778 16.64 18.077C16.343 18.374 16.016 18.643 15.667 18.879C15.315 19.117 14.941 19.32 14.553 19.483C14.158 19.65 13.744 19.779 13.324 19.866C12.46 20.041 11.538 20.041 10.678 19.866C10.256 19.779 9.84101 19.65 9.44501 19.482C9.05801 19.319 8.68401 19.116 8.33201 18.878C7.98501 18.645 7.65901 18.375 7.36101 18.078C7.06201 17.778 6.79201 17.45 6.55801 17.105C6.32101 16.754 6.11801 16.379 5.95301 15.99C5.78601 15.594 5.65801 15.181 5.57101 14.76C5.48301 14.329 5.43801 13.884 5.43801 13.437C5.43801 12.99 5.48301 12.545 5.57201 12.113C5.65801 11.693 5.78601 11.279 5.95301 10.883C6.11801 10.493 6.32201 10.118 6.55801 9.769C6.79201 9.422 7.06201 9.095 7.36001 8.797C7.65601 8.5 7.98301 8.23 8.33201 7.995C8.68201 7.759 9.05701 7.555 9.44601 7.39C9.84101 7.223 10.256 7.094 10.676 7.008C10.783 6.986 10.892 6.976 11 6.959V10L16 6L11 2V4.938C10.757 4.967 10.514 5 10.275 5.049C9.72501 5.162 9.18301 5.33 8.66701 5.549C8.15801 5.764 7.66801 6.03 7.21201 6.339C6.75801 6.645 6.33201 6.996 5.94501 7.383C5.55701 7.771 5.20601 8.197 4.90001 8.649C4.59101 9.106 4.32601 9.595 4.11001 10.104C3.89101 10.622 3.72301 11.163 3.61101 11.712C3.49501 12.275 3.43701 12.856 3.43701 13.438C3.43701 14.02 3.49601 14.6 3.61101 15.163C3.72401 15.714 3.89201 16.255 4.11001 16.77C4.32501 17.279 4.59101 17.769 4.90001 18.226C5.20501 18.676 5.55601 19.102 5.94501 19.494C6.33401 19.882 6.75901 20.233 7.21001 20.537C7.66901 20.848 8.15901 21.114 8.66601 21.327C9.18201 21.545 9.72301 21.714 10.275 21.827C10.839 21.941 11.419 22 12 22C12.581 22 13.161 21.941 13.727 21.826C14.278 21.712 14.819 21.544 15.331 21.327C15.838 21.114 16.329 20.848 16.788 20.537C17.241 20.231 17.667 19.88 18.056 19.491C18.444 19.102 18.795 18.677 19.101 18.225C19.413 17.763 19.677 17.273 19.889 16.77C20.109 16.25 20.278 15.709 20.389 15.162C20.504 14.599 20.563 14.018 20.563 13.437C20.563 12.857 20.504 12.276 20.389 11.712C20.277 11.166 20.108 10.625 19.89 10.105Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
      <v-snackbar v-model="snackbar.show">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <div>
            {{ snackbar.text }}
          </div>
          <v-btn class="transparent" text fab x-small dark @click="snackbar.show = false">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </div>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import { order, orderCalculation } from '@/api/order'
import { getVoucherDetail } from '@/api/voucher'
import { shipperList } from '@/api/shipping'
import { prepareCartItem } from '@/utils/order'
export default {
  data() {
    return {
      panel_va: [0, 1],
      order: {},
      timerInterval: null,
      distance: 0,
      snackbar: {
        show: false,
        text: ''
      },
      temporary_cart: {},
      temporary_shipping: {}
    }
  },
  computed: {
    formatDate() {
      if (!this.$isEmpty(this.order.payment_log)) {
        return this.frmtDate(new Date(this.order.payment_log.expired_at))
      } else {
        return this.frmtDate(new Date())
      }
    },
    formattedTimeLeft() {
      let hours = Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60))
      let result
      if (this.distance < 0) {
        result = this.$t('v2.expired')
      } else {
        hours = hours < 10 ? (hours === 0 ? '' : '0' + hours + 'h ') : hours + 'h '
        minutes = minutes < 10 ? '0' + minutes + 'm' : minutes + 'm'
        result = hours + minutes
      }
      return result
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order'))) {
      this.order = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order'))
      if (this.order.is_paid) {
        this.$router.push({ name: 'order', params: { id: this.order.id } }).catch(() => {})
      }
      const time = this.order.payment_log.expired_at
      this.getExpiryTime(time)
    } else {
      this.getOrder()
    }
    this.$store.dispatch('remove_cart')
  },
  methods: {
    frmtDate(date) {
      const tahun = date.getFullYear()
      let bulan = date.getMonth()
      const tanggal = date.getDate()
      switch (bulan) {
        case 0:
          bulan = this.$t('global.date.january')
          break
        case 1:
          bulan = this.$t('global.date.february')
          break
        case 2:
          bulan = this.$t('global.date.march')
          break
        case 3:
          bulan = this.$t('global.date.april')
          break
        case 4:
          bulan = this.$t('global.date.may')
          break
        case 5:
          bulan = this.$t('global.date.june')
          break
        case 6:
          bulan = this.$t('global.date.july')
          break
        case 7:
          bulan = this.$t('global.date.august')
          break
        case 8:
          bulan = this.$t('global.date.september')
          break
        case 9:
          bulan = this.$t('global.date.october')
          break
        case 10:
          bulan = this.$t('global.date.november')
          break
        case 11:
          bulan = this.$t('global.date.december')
          break
      }
      return tanggal + ' ' + bulan + ' ' + tahun
    },
    goToOrder(id) {
      this.$router.push({ name: 'order', params: { id: id } }).catch(() => {})
    },
    async getOrder() {
      try {
        const { data } = await order(this.order.id)
        this.order = data.data
        const time = this.order.payment_log.expired_at
        this.getExpiryTime(time)
      } catch (e) {
        this.order = {}
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    copyText() {
      const testingCodeToCopy = document.querySelector('#va_account_number')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()
      try {
        var successful = document.execCommand('copy')
        var msg = successful
          ? this.$t('order.number_was_copied_successfully')
          : this.$t('order.number_was_copied_unsuccessfully')
        this.snackbar.show = true
        this.snackbar.text = msg
      } catch (err) {
        this.snackbar.show = true
        this.snackbar.text = this.$t('order.unable_to_copy')
      }
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime()
      const _this = this
      this.timerInterval = setInterval(function () {
        var now = new Date().getTime()
        _this.distance = countDownDate - now
        if (_this.distance < 0) {
          clearInterval(_this.timerInterval)
        }
      }, 1000)
    },
    async checkVoucher(id) {
      try {
        const { data } = await getVoucherDetail(id)
        this.$set(this.temporary_cart, 'discount_voucher_id', id)
        this.$set(this.temporary_cart, 'discount_voucher_detail', data.data)
      } catch (e) {
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    async getShipper() {
      try {
        const { data } = await shipperList(this.temporary_cart)
        const shipperSupport = ['Instant', 'Same Day', 'Regular', 'Express', 'Cargo']
        const getData = data.data.filter(shipper => {
          if (shipperSupport.includes(shipper.name)) {
            if (shipper.item.length > 0) {
              return shipper
            }
          }
        })
        const idx_type = getData.findIndex(e => e.name === this.order.shipping_service_type)
        const idx = getData[idx_type].item.findIndex(
          e => e.courier_id === this.order.shipping_courier_id
        )
        const item = getData[idx_type].item[idx]
        const objShipper = {
          name: item.logistic_name,
          type: item.rate_type,
          shipping_courier_id: item.rate_id,
          shipping_service_type: item.rate_type,
          shipment_method: item.rate_type,
          shipment_working_hour: item.working_hour,
          price: item.final_price,
          logo: item.image_url,
          must_use_insurance: item.must_use_insurance,
          insurance_fee: item.insurance_fee,
          insurance_details: item.insurance_details,
          insurance_included: item.insurance_included
        }
        this.temporary_shipping = objShipper

        this.temporary_cart.shipping_courier_id = item.rate_id
        this.temporary_cart.shipping_service_type = this.order.shipping_service_type
        this.temporary_cart.shipping_insurance = false
      } catch (e) {
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    async changePayment(isCart = 0) {
      this.temporary_cart.item = []
      for (const item of this.order.items) {
        this.temporary_cart.item.push(prepareCartItem(item))
      }
      this.temporary_cart.remark = this.order.remark
      this.temporary_cart.currency_id = this.order.currency_id
      this.temporary_cart.notes = ''
      this.temporary_cart.shipping_address = ''
      this.temporary_cart.shipping_address_is_different = 1
      this.temporary_cart.without_shipping = 1
      if (!isCart) {
        this.temporary_cart.previousOrderId = this.order.id
        this.temporary_cart.shipping_address_id = null
        this.temporary_cart.shipping_address = this.order.shipping_address
        this.temporary_cart.shipping_lat = Number(this.order.shipping_lat)
        this.temporary_cart.shipping_lon = Number(this.order.shipping_lon)
        this.temporary_cart.shipping_subdistrict_id = this.order.shipping_subdistrict_id
        this.temporary_cart.shipping_city_id = this.order.shipping_city_id
        this.temporary_cart.shipping_country_id = this.order.shipping_country_id
        this.temporary_cart.shipping_name = 'Kantor'
        this.temporary_cart.shipping_note = this.order.shipping_note
        this.temporary_cart.notes = ''
        this.temporary_cart.without_shipping = this.order.remark === 'DELIVERY' ? 0 : 1
        this.temporary_cart.total = Number(this.order.total_amount)
        this.temporary_cart.shipping_radius = this.order.shipping_radius

        if (this.order.discount_voucher_id) {
          this.checkVoucher(this.order.discount_voucher_id)
        }

        if (this.order.remark === 'DELIVERY') {
          if (Number(this.order.shipping_delivery_type) === 2) {
            await this.getShipper()
          } else {
            this.temporary_shipping.id = 1
            this.temporary_shipping.type = 'free'
            this.temporary_shipping.name = 'Gratis Antar'
            this.temporary_shipping.remark = 'DELIVERY'
            this.temporary_shipping.logo = 'free_delivery'
            this.temporary_shipping.detail = 'Gratis'
            this.temporary_shipping.price = '0'
            this.temporary_shipping.fprice = 'IDR 0'
          }
        } else {
          this.temporary_shipping.id = 3
          this.temporary_shipping.type = 'SelfTake'
          this.temporary_shipping.name = 'Ambil Sendiri'
          this.temporary_shipping.remark = 'SELF PICK-UP'
          this.temporary_shipping.logo = 'pickup'
          this.temporary_shipping.detail = ''
          this.temporary_shipping.price = '0'
          this.temporary_shipping.fprice = 'IDR 0'
        }
        this.$store.commit('SET_TEMPORARY_SHIPPING', this.temporary_shipping)
      }

      try {
        await orderCalculation(this.temporary_cart, {
          globalLoading: false
        })
        this.$store.dispatch('saveDataCart', this.temporary_cart)
        if (isCart) {
          this.$router.push({ name: 'shopping_cart' })
        } else {
          this.$router.push({ name: 'payment_method' })
        }
      } catch (e) {
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
      this.$store.dispatch('remove_order')
    }
  }
}
</script>
